/**
 * The Leading Edge inspector roster (live-confirmed from Dropbox
 * `/Template folders/`; see docs/FIELD_MAPPING.md).
 *
 * Single source of truth for:
 *   - Backend Dropbox path parsing (only these names count as inspector folders)
 *   - The field PWA's login name picker
 *   - The admin dashboard's login picker + inspector filter
 *
 * Hardcoded because the team is static — if we add an inspector, we ship a
 * new build. Order here is display order in the UIs.
 */
export const KNOWN_INSPECTORS = [
    'Jason',
    'Tim',
    'Gareth',
    'Errin',
    'Jack',
    'Josh W',
    'Josh D',
    'Scott',
];
/**
 * CER consent and portal identity. Field staff may perform the site visit,
 * but Jason is the appointed inspector named on every consent/report record.
 */
export const CONSENT_INSPECTOR_NAME = 'Jason Satchell';
export const CONSENT_INSPECTOR_ID_CARD_NUMBER = '007CER-258';
//# sourceMappingURL=inspectors.js.map